import axios from "axios";
import { useEffect, useState } from "react";
import { baseUrl } from "../../../helper/urls";
import { Icon } from "@iconify/react/dist/iconify.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReadMoreText from "../../../components/ReadMoreText";
import { useSelector } from "react-redux";

const ProfilePage = (activateBank) => {
  const { token } = useSelector((state) => state.auth);

  // Add state for active tab
  const [activeTab, setActiveTab] = useState("personal");

  const [viewProfile, setViewProfileData] = useState([]);
  const [viewDocument, setViewDocument] = useState({});
  const [viewBank, setViewBank] = useState({
    bankName: "",
    RoutingNumber: "",
    AccountNo: "",
    ConfirmAccountNo: "",
    AccountType: "",
    id: "",
  });
  const [profileData, setProfileData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [cancelledChequeFile, setCancelledChequeFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isProfileLoading, setIsProfileLoading] = useState(true);
  const [formData, setFormData] = useState({
    bankName: "",
    RoutingNumber: "",
    AccountNo: "",
    ConfirmAccountNo: "",
    AccountType: "savings",
    id: "",
  });
  // const [formData, setFormData] = useState({
  //   bankName: viewBank?.bankName || "",
  //   RoutingNumber: viewBank?.RoutingNumber || "",
  //   AccountNo: viewBank?.AccountNo || "",
  //   ConfirmAccountNo: viewBank?.AccountNo || "",
  //   AccountType: viewBank?.AccountType || "savings",
  //   id: viewBank?.id || "",
  // });

  const [error, setError] = useState("");

  // Tab configuration
  const tabs = [
    { id: "personal", label: "Personal Details" },
    { id: "address", label: "Address" },
    { id: "documents", label: "Documents" },
    { id: "bank", label: "Bank Details" },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const handleCancelledChequeChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCancelledChequeFile(file);
    }
  };

  const removeCancelledCheque = () => {
    setCancelledChequeFile(null);
  };

  const ProfileData = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/api/counselors/getCounselorByToken`,
        { headers }
      );

      // console.log(response.data.data, "dataaaaaaaaaaaa");
      setProfileData(response.data.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  const viewProfileData = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/api/counselors/getPersonalDetails`,
        {
          headers: headers,
        }
      );
      setViewProfileData(response.data.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  const viewDocumentData = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/api/counselors/getDocumentByCounsolerId`,
        {
          headers: headers,
        }
      );
      setViewDocument(response.data.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  const viewBankData = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/api/counselors/getBankByCounsolerId`,
        {
          headers: headers,
        }
      );
      const bank = response.data.data;
      console.log(bank);
      setViewBank({
        bankName: bank?.bankName || "",
        RoutingNumber: bank?.RoutingNumber || "",
        AccountNo: bank?.AccountNo || "",
        ConfirmAccountNo: bank?.AccountNo || "",
        uploadedChequeUrl: bank?.CancelledCheque || "",
        AccountType: bank?.AccountType || "",
        id: bank?.id || "",
      });
      // setViewBank(bank);
      setFormData({
        bankName: bank?.bankName || "",
        RoutingNumber: bank?.RoutingNumber || "",
        AccountNo: bank?.AccountNo || "",
        ConfirmAccountNo: bank?.AccountNo || "",
        AccountType: bank?.AccountType || "",
        id: bank?.id || "",
      });
      setIsProfileLoading(false);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  useEffect(() => {
    ProfileData();
    viewProfileData();
    viewDocumentData();
    viewBankData();
  }, []);

  useEffect(() => {
    if (!profileData?.bank) {
      setActiveTab("bank");
    } else {
      setActiveTab("personal");
    }
  }, [profileData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "AccountNo" || name === "ConfirmAccountNo") {
      setError("");
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (formData.AccountNo !== formData.ConfirmAccountNo) {
      setError("Account Number and Confirm Account Number do not match.");
      return;
    }

    const data = new FormData();
    data.append("bankName", formData.bankName);
    data.append("RoutingNumber", formData.RoutingNumber);
    data.append("AccountNo", formData.AccountNo);
    data.append("AccountType", formData.AccountType || "savings");
    data.append("id", formData.id);
    data.append("CancelledCheque", cancelledChequeFile);

    setIsLoading(true);
    console.log("formatdata:::::::::::::::", data);
    const endpoint = formData.id ? "updateBank" : "createBank";
    try {
      const res = await axios.post(
        `${baseUrl}/api/counselors/${endpoint}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success(res.data.message);
      setIsLoading(false);
      setIsEditing(false);
      setActiveTab("personal");
      window.location.reload();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const renderPersonalDetails = () => (
    <div className="row">
      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            Full Name
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {profileData?.firstName} {profileData?.lastName}
          </span>
        </li>
      </div>

      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            Email
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {profileData?.email}
          </span>
        </li>
      </div>

      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            Phone
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {profileData?.country_code}-{profileData?.phone}
          </span>
        </li>
      </div>

      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            University
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {profileData?.universityName}
          </span>
        </li>
      </div>

      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            Major Course
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {profileData?.majorCourse}
          </span>
        </li>
      </div>

      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            SAT/ACT Score
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {profileData?.satActScore}
          </span>
        </li>
      </div>

      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            Service Type
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {profileData?.interestedIn}
          </span>
        </li>
      </div>
    </div>
  );

  const renderAddressDetails = () => (
    <div className="row">
      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            Country
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {viewProfile?.country}
          </span>
        </li>
      </div>
      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            State
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {viewProfile?.state}
          </span>
        </li>
      </div>
      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            City
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {viewProfile?.city}
          </span>
        </li>
      </div>
      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            Zip Code
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {viewProfile?.zipCode}
          </span>
        </li>
      </div>
      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            Full Address
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            : {viewProfile?.address}
          </span>
        </li>
      </div>
      <div className="col-sm-10">
        <li className="d-flex align-items-center gap-1 mb-12">
          <span className="w-30 text-md fw-semibold text-primary-light">
            {viewProfile?.SSN ? "SSN" : "EIN"}
          </span>
          <span className="w-70 text-secondary-light fw-medium">
            :{" "}
            {(() => {
              const raw = viewProfile?.SSN || viewProfile?.EIN;
              if (!raw) return "N/A";

              const digitsOnly = raw.replace(/\D/g, "");

              const last4 = digitsOnly.slice(-4);
              return viewProfile?.SSN ? ` XXX-XX-${last4}` : ` XX-XXX${last4}`;
            })()}
          </span>
        </li>
      </div>
    </div>
  );

  const renderDocuments = () => (
    <div className="col-sm-10">
      <li className="d-flex align-items-center gap-1 mb-12">
        <span className="w-30 text-md fw-semibold text-primary-light">
          Work Authorization
        </span>
        <span className="w-70 text-secondary-light fw-medium">
          :
          {viewDocument?.workAuthDocument ? (
            <a
              href={`${baseUrl}${viewDocument.workAuthDocument}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ms-2 text-primary fw-medium"
            >
              View File
            </a>
          ) : (
            <span className="ms-2">No file uploaded</span>
          )}
        </span>
      </li>
    </div>
  );
  const handleEditFuc = (e) => {
    e.preventDefault();
    setIsEditing(!isEditing);
  };
  const renderBankDetails = () => (
    <div style={{ position: "relative" }}>
      <button
        className="btn btn-sm btn-outline-primary position-absolute top-0 end-0 m-2"
        onClick={handleEditFuc}
      >
        {isEditing ? (
          "Cancel"
        ) : (
          <Icon icon="mdi:pencil" className="menu-icon" size={6} />
        )}
      </button>
      {isEditing ? (
        <div className="flex justify-center items-center text-center">
          <p
            className="text-sm justify-content-center"
            style={{ color: "#CA8A04" }}
          >
            Please enter your bank details carefully. This information will be
            used for weekly session payouts.
          </p>
        </div>
      ) : (
        ""
      )}
      <div className="col-sm-10 mt-4">
        <li className="d-flex align-items-center gap-2 mb-3">
          <span className="w-30 fw-semibold">Bank Name</span>
          <span className="w-70">
            {isEditing ? (
              <input
                type="text"
                name="bankName"
                className="form-control"
                value={formData.bankName}
                onChange={handleChange}
              />
            ) : (
              `: ${viewBank?.bankName}`
            )}
          </span>
        </li>

        <li className="d-flex align-items-center gap-2 mb-3">
          <span className="w-30 fw-semibold">Routing Number</span>
          <span className="w-70">
            {isEditing ? (
              <input
                type="text"
                name="RoutingNumber"
                className="form-control"
                value={formData.RoutingNumber}
                onChange={handleChange}
              />
            ) : (
              `: ${viewBank?.RoutingNumber}`
            )}
          </span>
        </li>

        <li className="d-flex align-items-center gap-2 mb-3">
          <span className="w-30 fw-semibold">Bank A/C</span>
          <span className="w-70">
            {isEditing ? (
              <input
                type="text"
                name="AccountNo"
                className="form-control"
                value={formData.AccountNo}
                onChange={handleChange}
              />
            ) : (
              `: ${viewBank?.AccountNo}`
            )}
          </span>
        </li>
        <li className="d-flex align-items-center gap-2 mb-3">
          <span className="w-30 fw-semibold">Confirm Bank A/C</span>
          <span className="w-70">
            {isEditing ? (
              <input
                type="text"
                name="ConfirmAccountNo"
                className="form-control"
                value={formData.ConfirmAccountNo}
                onChange={handleChange}
              />
            ) : (
              `: ${viewBank?.AccountNo}` // Or you can show nothing
            )}
          </span>
        </li>

        <li className="d-flex align-items-center gap-2 mb-3">
          <span className="w-30 fw-semibold">Cancelled Cheque Photo</span>:
          <span>
            {viewBank?.uploadedChequeUrl ? (
              <a
                href={`${baseUrl}${viewBank?.uploadedChequeUrl}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Cancelled Cheque
              </a>
            ) : (
              ": No file uploaded"
            )}
          </span>
          {isEditing ? (
            <>
              <label
                htmlFor="file-upload-name"
                className="mb-16 border border-neutral-600 fw-medium text-secondary-light px-16 py-12 radius-12 d-inline-flex align-items-center gap-2 bg-hover-neutral-200"
              >
                <Icon icon="solar:upload-linear" className="text-xl" />
                Cancelled Cheque Photo
                <input
                  type="file"
                  className="form-control w-auto mt-24 form-control-lg"
                  id="file-upload-name"
                  hidden
                  onChange={handleCancelledChequeChange}
                />
              </label>
              {cancelledChequeFile && (
                <div className="d-flex align-items-center gap-2">
                  <span>{cancelledChequeFile.name}</span>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={removeCancelledCheque}
                    type="button"
                  >
                    Remove
                  </button>
                </div>
              )}
            </>
          ) : (
            !cancelledChequeFile &&
            viewBank?.CancelledCheque && (
              <a
                href={`${baseUrl}${viewBank.CancelledCheque}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary fw-medium"
              >
                View File
              </a>
            )
          )}
        </li>

        <li className="d-flex align-items-center gap-2 mb-3">
          <span className="w-30 fw-semibold">Account Type</span>
          <span className="w-70">
            {isEditing ? (
              <select
                name="AccountType"
                className="form-select"
                value={formData.AccountType}
                onChange={handleChange}
              >
                <option value="savings">Savings</option>
                <option value="checking">Checking</option>
              </select>
            ) : (
              `: ${viewBank?.AccountType}`
            )}
          </span>
        </li>
      </div>

      {isEditing && (
        <button
          className="btn btn-sm btn-outline-primary position-absolute bottom-0 end-0 m-2"
          onClick={handleUpdate}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Saving...
            </>
          ) : (
            "Save"
          )}
        </button>
      )}
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case "personal":
        return renderPersonalDetails();
      case "address":
        return renderAddressDetails();
      case "documents":
        return renderDocuments();
      case "bank":
        return renderBankDetails();
      default:
        return renderPersonalDetails();
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      {isProfileLoading ? (
        <div>Loading Profile...</div>
      ) : (
        <div className="row gy-4">
          <div className="col-lg-12">
            <div className="user-grid-card position-relative overflow-hidden h-100">
              <div className="">
                <div className="border radius-16 bg-base p-3">
                  <div className="row g-4">
                    {/* Left Section */}
                    <div className="col-12 col-lg-3 d-flex justify-content-center align-items-center ">
                      <div className="text-center">
                        <div className="d-flex justify-content-center align-items-center ">
                          <div
                            className="d-flex justify-content-center align-items-center "
                            style={{ width: "150px", height: "150px" }}
                          >
                            <img
                              src={
                                profileData.profileImage
                                  ? `${baseUrl}${profileData.profileImage}`
                                  : "https://www.w3schools.com/howto/img_avatar.png"
                              }
                              alt="User Avatar"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "50%",
                                objectFit: "cover",
                                border: "2px solid white",
                              }}
                            />
                          </div>
                        </div>
                        {profileData.firstName && (
                          <h6 className="mb-0 mt-16">{`${profileData.firstName} ${profileData.lastName}`}</h6>
                        )}
                        {profileData.email && (
                          <span className="text-secondary-light mb-16">
                            {profileData.email}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Right Section */}
                    <div className="col-12 col-lg-9">
                      <div className="mt-24">
                        <div className="row mt-3">
                          <div className="col-12">
                            <span className="text-primary-light text-sm justify-text">
                              {profileData.testimony && (
                                <ReadMoreText
                                  text={profileData.testimony}
                                  maxLength={950}
                                />
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="card h-100">
              <div className="card-body p-24">
                {/* Tab Navigation */}
                <ul
                  className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                  id="pills-tab"
                  role="tablist"
                >
                  {tabs.map((tab) => (
                    <li className="nav-item" role="presentation" key={tab.id}>
                      <button
                        className={`nav-link d-flex align-items-center px-24 ${
                          activeTab === tab.id ? "active" : ""
                        }`}
                        onClick={() => handleTabClick(tab.id)}
                        type="button"
                        role="tab"
                      >
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>

                {/* Tab Content */}
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    role="tabpanel"
                    tabIndex={0}
                    style={{
                      border: "1px solid lightgray",
                      padding: "12px",
                      borderRadius: "13px",
                    }}
                  >
                    <form action="#">{renderTabContent()}</form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfilePage;

// import axios from "axios";
// import { useEffect, useState } from "react";
// import { baseUrl } from "../../../helper/urls";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import ReadMoreText from "../../../components/ReadMoreText";

// const ProfilePage = (activateBank) => {
//   const { token } = useSelector((state) => state.auth);

//   // Add state for active tab
//   const [activeTab, setActiveTab] = useState("personal");

//   const [viewProfile, setViewProfileData] = useState([]);
//   const [viewDocument, setViewDocument] = useState({});
//   const [viewBank, setViewBank] = useState({
//     bankName: "",
//     RoutingNumber: "",
//     AccountNo: "",
//     ConfirmAccountNo: "",
//     AccountType: "",
//     id: "",
//   });
//   const [profileData, setProfileData] = useState([]);
//   const [isEditing, setIsEditing] = useState(false);
//   const [cancelledChequeFile, setCancelledChequeFile] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     bankName: "",
//     RoutingNumber: "",
//     AccountNo: "",
//     ConfirmAccountNo: "",
//     AccountType: "savings",
//     id: "",
//   });
//   // const [formData, setFormData] = useState({
//   //   bankName: viewBank?.bankName || "",
//   //   RoutingNumber: viewBank?.RoutingNumber || "",
//   //   AccountNo: viewBank?.AccountNo || "",
//   //   ConfirmAccountNo: viewBank?.AccountNo || "",
//   //   AccountType: viewBank?.AccountType || "savings",
//   //   id: viewBank?.id || "",
//   // });

//   const [error, setError] = useState("");

//   // Tab configuration
//   const tabs = [
//     { id: "personal", label: "Personal Details" },
//     { id: "address", label: "Address" },
//     { id: "documents", label: "Documents" },
//     { id: "bank", label: "Bank Details" },
//   ];

//   const handleTabClick = (tabId) => {
//     setActiveTab(tabId);
//   };

//   const handleCancelledChequeChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setCancelledChequeFile(file);
//     }
//   };

//   const removeCancelledCheque = () => {
//     setCancelledChequeFile(null);
//   };

//   const ProfileData = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/counselors/getCounselorByToken`,
//         { headers }
//       );

//       // console.log(response.data.data, "dataaaaaaaaaaaa");
//       setProfileData(response.data.data);
//     } catch (error) {
//       console.error("Error fetching profile data:", error);
//     }
//   };

//   const viewProfileData = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/counselors/getPersonalDetails`,
//         {
//           headers: headers,
//         }
//       );
//       setViewProfileData(response.data.data);
//     } catch (error) {
//       console.error("Error fetching profile data:", error);
//     }
//   };

//   const viewDocumentData = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/counselors/getDocumentByCounsolerId`,
//         {
//           headers: headers,
//         }
//       );
//       setViewDocument(response.data.data);
//     } catch (error) {
//       console.error("Error fetching profile data:", error);
//     }
//   };

//   const viewBankData = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/counselors/getBankByCounsolerId`,
//         {
//           headers: headers,
//         }
//       );
//       const bank = response.data.data;
//       console.log(bank);
//       setViewBank({
//         bankName: bank?.bankName || "",
//         RoutingNumber: bank?.RoutingNumber || "",
//         AccountNo: bank?.AccountNo || "",
//         ConfirmAccountNo: bank?.AccountNo || "",
//         uploadedChequeUrl: bank?.CancelledCheque || "",
//         AccountType: bank?.AccountType || "",
//         id: bank?.id || "",
//       });
//       // setViewBank(bank);
//       setFormData({
//         bankName: bank?.bankName || "",
//         RoutingNumber: bank?.RoutingNumber || "",
//         AccountNo: bank?.AccountNo || "",
//         ConfirmAccountNo: bank?.AccountNo || "",
//         AccountType: bank?.AccountType || "",
//         id: bank?.id || "",
//       });
//     } catch (error) {
//       console.error("Error fetching profile data:", error);
//     }
//   };

//   useEffect(() => {
//     ProfileData();
//     viewProfileData();
//     viewDocumentData();
//     viewBankData();
//   }, []);

//   useEffect(() => {
//     if (!profileData?.bank) {
//       setActiveTab("bank");
//     } else {
//       setActiveTab("personal");
//     }
//   }, [profileData]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (name === "AccountNo" || name === "ConfirmAccountNo") {
//       setError("");
//     }
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     if (formData.AccountNo !== formData.ConfirmAccountNo) {
//       setError("Account Number and Confirm Account Number do not match.");
//       return;
//     }

//     const data = new FormData();
//     data.append("bankName", formData.bankName);
//     data.append("RoutingNumber", formData.RoutingNumber);
//     data.append("AccountNo", formData.AccountNo);
//     data.append("AccountType", formData.AccountType || "savings");
//     data.append("id", formData.id);
//     data.append("CancelledCheque", cancelledChequeFile);

//     setIsLoading(true);
//     console.log("formatdata:::::::::::::::", data);
//     const endpoint = formData.id ? "updateBank" : "createBank";
//     try {
//       const res = await axios.post(
//         `${baseUrl}/api/counselors/${endpoint}`,
//         data,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       toast.success(res.data.message);
//       setIsLoading(false);
//       setIsEditing(false);
//       setActiveTab("personal");
//       window.location.reload();
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const renderPersonalDetails = () => (
//     <div className="row">
//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             Full Name
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {profileData?.firstName} {profileData?.lastName}
//           </span>
//         </li>
//       </div>

//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             Email
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {profileData?.email}
//           </span>
//         </li>
//       </div>

//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             Phone
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {profileData?.country_code}-{profileData?.phone}
//           </span>
//         </li>
//       </div>

//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             University
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {profileData?.universityName}
//           </span>
//         </li>
//       </div>

//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             Major Course
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {profileData?.majorCourse}
//           </span>
//         </li>
//       </div>

//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             SAT/ACT Score
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {profileData?.satActScore}
//           </span>
//         </li>
//       </div>

//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             Service Type
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {profileData?.interestedIn}
//           </span>
//         </li>
//       </div>
//     </div>
//   );

//   const renderAddressDetails = () => (
//     <div className="row">
//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             Country
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {viewProfile?.country}
//           </span>
//         </li>
//       </div>
//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             State
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {viewProfile?.state}
//           </span>
//         </li>
//       </div>
//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             City
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {viewProfile?.city}
//           </span>
//         </li>
//       </div>
//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             Zip Code
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {viewProfile?.zipCode}
//           </span>
//         </li>
//       </div>
//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             Full Address
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             : {viewProfile?.address}
//           </span>
//         </li>
//       </div>
//       <div className="col-sm-10">
//         <li className="d-flex align-items-center gap-1 mb-12">
//           <span className="w-30 text-md fw-semibold text-primary-light">
//             {viewProfile?.SSN ? "SSN" : "EIN"}
//           </span>
//           <span className="w-70 text-secondary-light fw-medium">
//             :{" "}
//             {(() => {
//               const raw = viewProfile?.SSN || viewProfile?.EIN;
//               if (!raw) return "N/A";

//               const digitsOnly = raw.replace(/\D/g, "");

//               const last4 = digitsOnly.slice(-4);
//               return viewProfile?.SSN ? ` XXX-XX-${last4}` : ` XX-XXX${last4}`;
//             })()}
//           </span>
//         </li>
//       </div>
//     </div>
//   );

//   const renderDocuments = () => (
//     <div className="col-sm-10">
//       <li className="d-flex align-items-center gap-1 mb-12">
//         <span className="w-30 text-md fw-semibold text-primary-light">
//           Work Authorization
//         </span>
//         <span className="w-70 text-secondary-light fw-medium">
//           :
//           {viewDocument?.workAuthDocument ? (
//             <a
//               href={`${baseUrl}${viewDocument.workAuthDocument}`}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="ms-2 text-primary fw-medium"
//             >
//               View File
//             </a>
//           ) : (
//             <span className="ms-2">No file uploaded</span>
//           )}
//         </span>
//       </li>
//     </div>
//   );
//   const handleEditFuc = (e) => {
//     e.preventDefault();
//     setIsEditing(!isEditing);
//   };
//   const renderBankDetails = () => (
//     <div style={{ position: "relative" }}>
//       <button
//         className="btn btn-sm btn-outline-primary position-absolute top-0 end-0 m-2"
//         onClick={handleEditFuc}
//       >
//         {isEditing ? (
//           "Cancel"
//         ) : (
//           <Icon icon="mdi:pencil" className="menu-icon" size={6} />
//         )}
//       </button>
//       {isEditing ? (
//         <div className="flex justify-center items-center text-center">
//           <p
//             className="text-sm justify-content-center"
//             style={{ color: "#CA8A04" }}
//           >
//             Please enter your bank details carefully. This information will be
//             used for weekly session payouts.
//           </p>
//         </div>
//       ) : (
//         ""
//       )}
//       <div className="col-sm-10 mt-4">
//         <li className="d-flex align-items-center gap-2 mb-3">
//           <span className="w-30 fw-semibold">Bank Name</span>
//           <span className="w-70">
//             {isEditing ? (
//               <input
//                 type="text"
//                 name="bankName"
//                 className="form-control"
//                 value={formData.bankName}
//                 onChange={handleChange}
//               />
//             ) : (
//               `: ${viewBank?.bankName}`
//             )}
//           </span>
//         </li>

//         <li className="d-flex align-items-center gap-2 mb-3">
//           <span className="w-30 fw-semibold">Routing Number</span>
//           <span className="w-70">
//             {isEditing ? (
//               <input
//                 type="text"
//                 name="RoutingNumber"
//                 className="form-control"
//                 value={formData.RoutingNumber}
//                 onChange={handleChange}
//               />
//             ) : (
//               `: ${viewBank?.RoutingNumber}`
//             )}
//           </span>
//         </li>

//         <li className="d-flex align-items-center gap-2 mb-3">
//           <span className="w-30 fw-semibold">Bank A/C</span>
//           <span className="w-70">
//             {isEditing ? (
//               <input
//                 type="text"
//                 name="AccountNo"
//                 className="form-control"
//                 value={formData.AccountNo}
//                 onChange={handleChange}
//               />
//             ) : (
//               `: ${viewBank?.AccountNo}`
//             )}
//           </span>
//         </li>
//         <li className="d-flex align-items-center gap-2 mb-3">
//           <span className="w-30 fw-semibold">Confirm Bank A/C</span>
//           <span className="w-70">
//             {isEditing ? (
//               <input
//                 type="text"
//                 name="ConfirmAccountNo"
//                 className="form-control"
//                 value={formData.ConfirmAccountNo}
//                 onChange={handleChange}
//               />
//             ) : (
//               `: ${viewBank?.AccountNo}` // Or you can show nothing
//             )}
//           </span>
//         </li>

//         <li className="d-flex align-items-center gap-2 mb-3">
//           <span className="w-30 fw-semibold">Cancelled Cheque Photo</span>:
//           <span>
//             {viewBank?.uploadedChequeUrl ? (
//               <a
//                 href={`${baseUrl}${viewBank?.uploadedChequeUrl}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 View Cancelled Cheque
//               </a>
//             ) : (
//               ": No file uploaded"
//             )}
//           </span>
//           {isEditing ? (
//             <>
//               <label
//                 htmlFor="file-upload-name"
//                 className="mb-16 border border-neutral-600 fw-medium text-secondary-light px-16 py-12 radius-12 d-inline-flex align-items-center gap-2 bg-hover-neutral-200"
//               >
//                 <Icon icon="solar:upload-linear" className="text-xl" />
//                 Cancelled Cheque Photo
//                 <input
//                   type="file"
//                   className="form-control w-auto mt-24 form-control-lg"
//                   id="file-upload-name"
//                   hidden
//                   onChange={handleCancelledChequeChange}
//                 />
//               </label>
//               {cancelledChequeFile && (
//                 <div className="d-flex align-items-center gap-2">
//                   <span>{cancelledChequeFile.name}</span>
//                   <button
//                     className="btn btn-sm btn-danger"
//                     onClick={removeCancelledCheque}
//                     type="button"
//                   >
//                     Remove
//                   </button>
//                 </div>
//               )}
//             </>
//           ) : (
//             !cancelledChequeFile &&
//             viewBank?.CancelledCheque && (
//               <a
//                 href={`${baseUrl}${viewBank.CancelledCheque}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="text-primary fw-medium"
//               >
//                 View File
//               </a>
//             )
//           )}
//         </li>

//         <li className="d-flex align-items-center gap-2 mb-3">
//           <span className="w-30 fw-semibold">Account Type</span>
//           <span className="w-70">
//             {isEditing ? (
//               <select
//                 name="AccountType"
//                 className="form-select"
//                 value={formData.AccountType}
//                 onChange={handleChange}
//               >
//                 <option value="savings">Savings</option>
//                 <option value="checking">Checking</option>
//               </select>
//             ) : (
//               `: ${viewBank?.AccountType}`
//             )}
//           </span>
//         </li>
//       </div>

//       {isEditing && (
//         <button
//           className="btn btn-sm btn-outline-primary position-absolute bottom-0 end-0 m-2"
//           onClick={handleUpdate}
//           disabled={isLoading}
//         >
//           {isLoading ? (
//             <>
//               <span
//                 className="spinner-border spinner-border-sm me-2"
//                 role="status"
//                 aria-hidden="true"
//               ></span>
//               Saving...
//             </>
//           ) : (
//             "Save"
//           )}
//         </button>
//       )}
//     </div>
//   );

//   const renderTabContent = () => {
//     switch (activeTab) {
//       case "personal":
//         return renderPersonalDetails();
//       case "address":
//         return renderAddressDetails();
//       case "documents":
//         return renderDocuments();
//       case "bank":
//         return renderBankDetails();
//       default:
//         return renderPersonalDetails();
//     }
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} />
//       <div className="row gy-4">
//         <div className="col-lg-12">
//           <div className="user-grid-card position-relative overflow-hidden h-100">
//             <div className="">
//               <div className="border radius-16 bg-base p-3">
//                 <div className="row g-4">
//                   {/* Left Section */}
//                   <div className="col-12 col-lg-3 d-flex justify-content-center align-items-center ">
//                     <div className="text-center">
//                       <div className="d-flex justify-content-center align-items-center ">
//                         <div
//                           className="d-flex justify-content-center align-items-center "
//                           style={{ width: "150px", height: "150px" }}
//                         >
//                           <img
//                             src={
//                               profileData.profileImage
//                                 ? `${baseUrl}${profileData.profileImage}`
//                                 : "https://www.w3schools.com/howto/img_avatar.png"
//                             }
//                             alt="User Avatar"
//                             style={{
//                               width: "100%",
//                               height: "100%",
//                               borderRadius: "50%",
//                               objectFit: "cover",
//                               border: "2px solid white",
//                             }}
//                           />
//                         </div>
//                       </div>
//                       {profileData.firstName && (
//                         <h6 className="mb-0 mt-16">{`${profileData.firstName} ${profileData.lastName}`}</h6>
//                       )}
//                       {profileData.email && (
//                         <span className="text-secondary-light mb-16">
//                           {profileData.email}
//                         </span>
//                       )}
//                     </div>
//                   </div>

//                   {/* Right Section */}
//                   <div className="col-12 col-lg-9">
//                     <div className="mt-24">
//                       <div className="row mt-3">
//                         <div className="col-12">
//                           <span className="text-primary-light text-sm justify-text">
//                             {profileData.testimony && (
//                               <ReadMoreText
//                                 text={profileData.testimony}
//                                 maxLength={950}
//                               />
//                             )}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-12">
//           <div className="card h-100">
//             <div className="card-body p-24">
//               {/* Tab Navigation */}
//               <ul
//                 className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
//                 id="pills-tab"
//                 role="tablist"
//               >
//                 {tabs.map((tab) => (
//                   <li className="nav-item" role="presentation" key={tab.id}>
//                     <button
//                       className={`nav-link d-flex align-items-center px-24 ${
//                         activeTab === tab.id ? "active" : ""
//                       }`}
//                       onClick={() => handleTabClick(tab.id)}
//                       type="button"
//                       role="tab"
//                     >
//                       {tab.label}
//                     </button>
//                   </li>
//                 ))}
//               </ul>

//               {/* Tab Content */}
//               <div className="tab-content" id="pills-tabContent">
//                 <div
//                   className="tab-pane fade show active"
//                   role="tabpanel"
//                   tabIndex={0}
//                   style={{
//                     border: "1px solid lightgray",
//                     padding: "12px",
//                     borderRadius: "13px",
//                   }}
//                 >
//                   <form action="#">{renderTabContent()}</form>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ProfilePage;
